export const useIsDevEnvironment = (): boolean => {
  const { hostname } = window.location
  if (hostname === 'app.teamtim.fr') return false
  if (hostname === 'app.team-tim.fr') return false
  return true
}
